(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.sbInit) return;
    root.dataset.sbInit = '1';

    var dataEl = root.querySelector('[data-sb-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('#sb-form');
    var idInput = root.querySelector('#sb-variant-id');
    var qtyInput = root.querySelector('#sb-qty');
    var addBtn = root.querySelector('#sb-add');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var mainImg = root.querySelector('#sb-main-image');

    root.querySelectorAll('.sb-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.sb-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (mainImg) { mainImg.src = t.dataset.src; mainImg.srcset = ''; mainImg.alt = t.dataset.alt || ''; }
      });
    });

    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = parseInt(qtyInput.value || '1', 10) + parseInt(b.dataset.qty, 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney && window.sbMoneyFormat) {
        return Shopify.formatMoney(cents, window.sbMoneyFormat);
      }
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function updateVariant() {
      var chosen = [];
      root.querySelectorAll('.sb-option').forEach(function (g) {
        var a = g.querySelector('.sb-value.is-active');
        chosen.push(a ? a.dataset.value : null);
      });
      if (!chosen.length) return;

      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return !val || v.options[i] === val; });
      });
      if (!match) return;

      idInput.value = match.id;

      var priceEl = root.querySelector('#sb-price');
      var wasEl = root.querySelector('#sb-was');
      var saveEl = root.querySelector('#sb-save');
      var stickyPrice = document.querySelector('#sb-sticky-price');
      var onSale = match.compare_at_price && match.compare_at_price > match.price;

      if (priceEl) priceEl.textContent = money(match.price);
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      if (wasEl) { wasEl.textContent = onSale ? money(match.compare_at_price) : ''; wasEl.hidden = !onSale; }
      if (saveEl) { saveEl.textContent = onSale ? 'You save ' + money(match.compare_at_price - match.price) : ''; saveEl.hidden = !onSale; }
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (window.history && history.replaceState) {
        history.replaceState({}, '', root.dataset.url + '?variant=' + match.id);
      }
    }

    root.querySelectorAll('.sb-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.sb-option').querySelectorAll('.sb-value').forEach(function (v) { v.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateVariant();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput.value || '1', 10) })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('sb:cart:added'));
            window.location.href = rootUrl + 'cart';
          })
          .catch(function () { if (addBtn) addBtn.disabled = false; });
      });
    }

    root.querySelectorAll('.sb-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('.sb-tab').forEach(function (t) {
          t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        root.querySelectorAll('.sb-panel').forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      });
    });

    var clock = root.querySelector('.sb-clock');
    if (clock) {
      var deadline = Date.parse(clock.dataset.deadline);
      if (isNaN(deadline)) deadline = Date.now() + 6 * 3600 * 1000;
      var h = clock.querySelector('[data-h]'), m = clock.querySelector('[data-m]'), s = clock.querySelector('[data-s]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        h.textContent = pad(Math.floor(left / 3600));
        m.textContent = pad(Math.floor(left / 60) % 60);
        s.textContent = pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }

    var rec = root.querySelector('[data-related]');
    if (rec && !rec.querySelector('.sb-pcard')) {
      fetch(rec.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-related-grid]');
          if (grid) rec.querySelector('[data-related-grid]').innerHTML = grid.innerHTML;
        });
    }
  }

  function boot() { document.querySelectorAll('.sb-root').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.sb-root')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
// No JS required

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopbeta-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.sbcInit) return;
    root.dataset.sbcInit = '1';

    var sectionId = root.dataset.section;
    var timer;

    function go(url, push) {
      root.classList.add('is-loading');
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.sbc-root');
          if (!fresh) { window.location.href = url; return; }
          root.querySelector('[data-sb-filters]').innerHTML = fresh.querySelector('[data-sb-filters]').innerHTML;
          root.querySelector('[data-sb-results]').innerHTML = fresh.querySelector('[data-sb-results]').innerHTML;
          if (push !== false) history.pushState({}, '', url);
          root.classList.remove('is-loading');
        })
        .catch(function () { window.location.href = url; });
    }

    function urlFromForm() {
      var form = root.querySelector('[data-sb-filter-form]');
      var params = form ? new URLSearchParams(new FormData(form)).toString() : '';
      params = params.split('&').filter(function (p) { return p.split('=')[1]; }).join('&');
      return window.location.pathname + (params ? '?' + params : '');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-sb-sort]')) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', e.target.value);
        u.searchParams.delete('page');
        go(u.pathname + u.search);
        return;
      }
      if (e.target.closest('[data-sb-filter-form]')) {
        clearTimeout(timer);
        timer = setTimeout(function () { go(urlFromForm()); }, e.target.type === 'number' ? 500 : 0);
      }
    });

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-sb-link]');
      if (link) { e.preventDefault(); go(link.getAttribute('href')); }
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sb-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = btn.querySelector('span');
      btn.disabled = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
      })
                 .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('sb:cart:added'));
          window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () { btn.disabled = false; });
    });

    window.addEventListener('popstate', function () { go(window.location.href, false); });
  }

  function boot() { document.querySelectorAll('.sbc-root').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.sbc-root') : null;
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
